import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import axios from "../../utils/axios";

const useProtectedCharacteristics = () =>
    useQuery([queryKeys.protectedCharacteristics], () => {
        return axios.get<any, any>(`${process.env.REACT_APP_CASENEST_API_URL}/protectedcharacteristics`);
    }, {
        staleTime: 600000,
        cacheTime: 900000
    });

export default useProtectedCharacteristics;
